import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';

import { Close } from '@mui/icons-material';
import { HandlersUserDetailResponse } from '../../../../../app/athenaApiGen';
interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  userToDelete: {
    user: HandlersUserDetailResponse;
    idx: number;
  } | null;
  onConfirm: () => void;
  getRolesString: (user: HandlersUserDetailResponse) => string;
}

export default function DeleteUserDialog({
  open,
  onClose,
  userToDelete,
  onConfirm,
  getRolesString,
}: DeleteUserDialogProps) {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          color: 'error.main',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        Confirm User Deletion
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this user?
        </Typography>
        {userToDelete && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor:
                theme.palette.mode === 'light' ? 'transparent' : 'grey.100',
              borderRadius: 1,
              border:
                theme.palette.mode === 'light' ? '1px solid #B8B8B8' : 'none',
            }}
          >
            <Typography variant="body2">
              <strong>Name:</strong>{' '}
              {userToDelete.user.userName ||
                userToDelete.user.contact?.name ||
                'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Email:</strong> {userToDelete.user.userEmail || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Roles:</strong>{' '}
              {getRolesString(userToDelete.user) || 'None'}
            </Typography>
          </Box>
        )}
        <Typography variant="body2" color="error.main" sx={{ mt: 2 }}>
          <strong>Warning:</strong> This action cannot be undone. This will
          permanently delete the user and revoke all permissions including View
          Financial Dashboard, Create/Edit/Approve Deliverables, and Project
          access.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            ml: 1,
            backgroundColor: 'transparent',
            color: 'error.main',
            border: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          Delete User
        </Button>
      </DialogActions>
    </Dialog>
  );
}
